// TODO: Generate this file as part of the build process

export function getPinmuxToolVersion() {
    return "v26.09.0"
}
